import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';

/**
 * Re-exported rather than redeclared: this used to be a second, identical copy
 * of the type in `@hakimo-ui/hakimo/types`, and values produced there flow into
 * the consumers here. One declaration, both import paths.
 */
export type { EscalationState } from '@hakimo-ui/hakimo/types';

export interface CameraDetails {
  cameraId: string;
  cameraName: string;
  cameraGroupId: string;
  cameraGroupName: string;
  cameraLiveStreamUrl: string;
  cameraPlayBackUrl: string;
  alarms: UnifiedAlarm[];
  isAlarmVideoDisabled?: boolean;
  alarmStartAndEndTimes?: [number, number][];
  isTalkdownEnabled: boolean;
}

export interface AlarmDetails {
  cameraId: string;
  startTime: number;
  endTime: number;
}

export enum CameraFeedMode {
  LIVE = 'live',
  PLAYBACK = 'playback',
  ALARM_VIDEO = 'alarm_video',
  SPLIT = 'split',
}

export interface SectionDimension {
  width: number;
  height: number;
}

export interface Position {
  top: number;
  left: number;
  width: number;
  height: number;
}

export interface TimelineBounds {
  alarmGroupStartTime: number;
  alarmGroupEndTime: number;
  totalTimelineStartTime: number;
  totalTimelineEndTime: number;
}

export interface CameraAlarmTracker {
  currentAlarmId: string;
  showAlarmIds: Set<string>;
  preloadAlarmIds: Set<string>;
  isCamShownCurrently?: boolean;
}

export interface EnterpriseAlarmDetails {
  tap?: number;
  alarmTime?: string;
  alarmType?: string;
  employee?: string;
  alarmSourceSystem?: string;
  sourceEntity?: string;
  camera?: string;
}

export interface UseTimelineZoomParams {
  totalStart: number;
  totalEnd: number;
  onRequestExtendBounds?: (pastMs: number, futureMs: number) => void;
}

export interface ViewWindow {
  start: number;
  end: number;
}

export interface UseTimelineZoomReturn {
  viewStart: number;
  viewEnd: number;
  thumbLeftPercent: number;
  thumbWidthPercent: number;
  isZoomed: boolean;
  zoomAtCursor: (cursorFraction: number, zoomIn: boolean) => void;
  panByFraction: (deltaFraction: number) => void;
  panToThumbLeft: (newThumbLeftPercent: number) => void;
  resetZoom: () => void;
}

export interface TimelineScrollbarProps {
  thumbLeftPercent: number;
  thumbWidthPercent: number;
  onThumbDragStart: () => void;
  onThumbDrag: (newThumbLeftPercent: number) => void;
}

// Re-export context types from contexts folder
export type {
  AlarmGroupCameraContextType,
  AlarmGroupPlaybackContextType,
  AlarmGroupStaticContextType,
  AlarmGroupTimeContextType,
} from './alarm-provider/contexts';
